<template>
  <div id="delivery-history" class="delivery-history">
    <b-modal ref="deliveryHistoryModal" size="lg" no-close-on-backdrop hide-footer :static="true" title="Delivery History" @hide="cancel">
      <b-form class="delivery-history-range-form" @submit.prevent="build()">
        <b-row>
          <b-col col cols="12" xl="5">
            <b-input-group>
              <b-form-input
                id="delivery-start-date"
                v-model="deliveryStartDateString"
                type="text"
                size="sm"
                placeholder="MM/DD/YY"
                autocomplete="off"
                maxlength="8"
                @input="onStartDateChange"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  button-only
                  left
                  id="delivery-start-date-icon"
                  size="sm"
                  :max="deliveryEndDate"
                  value-as-date
                  hide-header
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  v-model="deliveryStartDate"
                  @context="onStartDateContext"
                ></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col col cols="12" xl="5">
            <b-input-group>
              <b-form-input
                id="delivery-end-date"
                v-model="deliveryEndDateString"
                type="text"
                size="sm"
                placeholder="MM/DD/YY"
                autocomplete="off"
                maxlength="8"
                :state="endDateState"
                @input="onEndDateChange"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  button-only
                  left
                  id="delivery-end-date-icon"
                  size="sm"
                  :min="deliveryStartDate"
                  :max="maxEnd"
                  value-as-date
                  hide-header
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  v-model="deliveryEndDate"
                  @context="onEndDateContext"
                ></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col col cols="12" xl="2">
            <b-button id="delivery-history-filter-btn" type="submit" variant="kag-dark-blue" block size="sm" :disabled="endDateState === false">Filter</b-button>
          </b-col>
        </b-row>
      </b-form>
      <div>
        <b-table
          id="delivery-history-table"
          class="delivery-history-table"
          bordered
          small
          no-border-collapse
          responsive="lg"
          primary-key="id"
          :items="orders"
          :fields="tableFields"
          :sort-by="'creationDate'"
          :sort-desc="true"
        >
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory'
import moment from 'moment-timezone'
import global from '@/mixins/shared/global'

const CompanyRepo = RepositoryFactory.get('CompanyRepository')

export default {
  name: 'DeliveryHistory',
  data () {
    const startDate = new Date()
    startDate.setHours(0)
    startDate.setMinutes(0)
    startDate.setSeconds(0)
    startDate.setMilliseconds(0)
    startDate.setDate(startDate.getDate() - 3)
    const endDate = new Date()
    endDate.setHours(23)
    endDate.setMinutes(59)
    endDate.setSeconds(59)
    endDate.setMilliseconds(999)
    const maxEndDate = new Date()
    maxEndDate.setHours(23)
    maxEndDate.setMinutes(59)
    maxEndDate.setSeconds(59)
    maxEndDate.setMilliseconds(999)

    return {
      siteId: null,
      orders: [],
      tableFields: [
        { key: 'orderHdrNumber', label: 'Number' },
        { key: 'shipperUniqueId', label: 'Shipper' },
        { key: 'orderDropCount', label: 'Drops' },
        { key: 'commodityCode', label: 'Commodity Code' },
        { key: 'commodityClass', label: 'Commodity Class' },
        { key: 'stopTotalVolume', label: 'Qty' },
        { key: 'arrivalDate', label: 'ETA' },
        { key: 'mppFullName', label: 'Driver' }
      ],
      deliveryStartDateString: global.buildShortDateString(startDate),
      deliveryStartDate: startDate,
      deliveryEndDateString: global.buildShortDateString(endDate),
      deliveryEndDate: endDate,
      maxEnd: maxEndDate
    }
  },
  methods: {
    build () {
      if (this.siteId == null) return
      this.orders = []
      CompanyRepo.getCompletedOrdersByDate(this.siteId, this.deliveryStartDate, this.deliveryEndDate).then((response) => {
        if (response && response.data && response.data.length) {
          this.orders = response.data
          this.orders.forEach(o => {
            o.arrivalDate = this.formatDate(new Date(o.arrivalDate))
          })
        }
      })
    },
    cancel () {
      this.clear()
      this.$refs.deliveryHistoryModal.hide()
    },
    show (opts = {}) {
      if (opts.siteId) {
        this.siteId = opts.siteId
        this.build()
      }

      this.$refs.deliveryHistoryModal.show()
    },
    clear () {
      this.siteId = null
      this.orders = []
      const startDate = new Date()
      startDate.setHours(0)
      startDate.setMinutes(0)
      startDate.setSeconds(0)
      startDate.setMilliseconds(0)
      startDate.setDate(startDate.getDate() - 3)
      const endDate = new Date()
      endDate.setHours(23)
      endDate.setMinutes(59)
      endDate.setSeconds(59)
      endDate.setMilliseconds(999)
      const maxEndDate = new Date()
      maxEndDate.setHours(23)
      maxEndDate.setMinutes(59)
      maxEndDate.setSeconds(59)
      maxEndDate.setMilliseconds(999)
      this.maxEnd = maxEndDate
      this.deliveryStartDate = startDate
      this.deliveryStartDateString = global.buildShortDateString(startDate)
      this.deliveryEndDate = endDate
      this.deliveryEndDateString = global.buildShortDateString(endDate)
    },
    formatDate (date) {
      return moment(date).format('MM/DD HH:mm')
    },
    onStartDateChange (text) {
      if (text.match(global.sixDigitRegex)) {
        this.deliveryStartDateString = `${text.substring(0, 2)}/${text.substring(2, 4)}/${text.substring(4, 6)}`
        this.onStartDateChange(this.deliveryStartDateString)
      } else {
        if (text.match(global.shortDateRegex)) {
          const split = text.split('/')
          this.deliveryStartDate = new Date((+split[2] + 2000), +split[0] - 1, +split[1])
        }
      }
    },
    formatSelectedDate (ctx) {
      return `${('0' + (+ctx.selectedDate.getMonth() + 1)).slice(-2)}/${('0' + ctx.selectedDate.getDate()).slice(-2)}/${ctx.selectedDate.getFullYear().toString().substring(2, 4)}`
    },
    onStartDateContext (ctx) {
      this.deliveryStartDateString = this.formatSelectedDate(ctx)
    },
    onEndDateChange (text) {
      if (text.match(global.sixDigitRegex)) {
        this.deliveryEndDateString = `${text.substring(0, 2)}/${text.substring(2, 4)}/${text.substring(4, 6)}`
        this.onEndDateChange(this.deliveryEndDateString)
      } else {
        if (text.match(global.dateRegex)) {
          const split = text.split('/')
          this.deliveryEndDate = new Date((+split[2] + 2000), +split[0] - 1, +split[1])
        }
      }
    },
    onEndDateContext (ctx) {
      this.deliveryEndDateString = this.formatSelectedDate(ctx)
    }
  },
  computed: {
    endDateState () {
      if (this.deliveryEndDateString.match(global.shortDateRegex)) {
        if (this.deliveryEndDate.getTime() >= this.deliveryStartDate.getTime() && this.deliveryEndDate.getTime() <= this.maxEnd.getTime()) {
          return null
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/themes/theme';

.delivery-history-table {
  margin-top: 20px;
}
</style>
